import Vue from 'vue'

Vue.filter('TransactionDesriptionFilter', function (transaction) {
  const TYPE_WITHDRAWAL = 1
  const TYPE_DEPOSIT = 2

  if (transaction.type === TYPE_WITHDRAWAL) {
    return 'Refund'
  } else if (transaction.type === TYPE_DEPOSIT) {
    return 'Fund'
  } else {
    return 'Transfer'
  }
})

Vue.filter('TransactionViaFilter', function (transaction) {
  let paymentMethod = null

  const notCreditIds = []

  const TYPES_NOT_CREDIT_CARD = [
    {'id' : 1, 'name': 'Cash'},
    {'id' : 2, 'name': 'Bank'},
    {'id' : 5, 'name': 'Paypal'}
  ]

  TYPES_NOT_CREDIT_CARD.forEach(element => {
    notCreditIds.push(element.id)
  })

  if (notCreditIds.includes(transaction.payment_type_id)) {
    paymentMethod = TYPES_NOT_CREDIT_CARD.find(ele => {
      return ele.id === transaction.payment_type_id
    })
  }

  return `${paymentMethod === null ? ' Credit card' : paymentMethod.name}`
})
